import { sendEventToGTM } from '@neptune/analytics-domain';
import { useDeepCompareEffect } from 'common/hooks/useDeepCompareEffect';

type Attributes = {
  isDefault: 'true' | 'false';
  projectName: string;
  projectRole: string;
  organizationName: string;
  isArchived: 'true' | 'false';
};

type ProjectEventName =
  | 'dashboard_is_viewed'
  | 'run_details_are_viewed'
  | 'compare_is_viewed'
  | 'models_tab_is_viewed'
  | 'model_details_are_viewed'
  | 'table_view_is_viewed'
  | 'project_metadata_is_viewed'
  | 'projects_tab_is_viewed'
  | 'project_is_viewed'
  | 'report_is_viewed';

type UseAnalyticsProjectEventParams = {
  eventName: ProjectEventName;
  senderUsername: string | undefined;
  attributes?: Partial<Attributes>;
  enabled?: boolean;
  deps?: unknown[];
};

export const useViewedEvent = ({
  eventName,
  senderUsername = 'unknown',
  attributes,
  enabled = true,
  deps = [],
}: UseAnalyticsProjectEventParams) => {
  // useDeepCompareEffect is used to avoid extra calls from changes at attributes
  useDeepCompareEffect(() => {
    if (enabled) {
      sendEventToGTM({
        eventName,
        senderUsername,
        attributes,
      });
    }
  }, [eventName, senderUsername, attributes, enabled, ...deps]);
};
